
export default {
  name: 'MobileMenu',
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    closeMenu() {
      this.$store.commit('mobile-menu/switchBtn', false);
    },
  },
};
